import api from "./api";

export const loginWithPhone = async (phone_no) => {
  try {
    const response = await api.post("/auth/register-user", { phone_no });
    return response.data;
  } catch (error) {
    throw error.response.data.message;
  }
};

export const login = async (reqData) => {
  try {
    const { email, password } = reqData;
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    if (!API_KEY) {
      throw new Error("API key is missing");
    }

    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.post(
      "/auth/login",
      { email, password },
      {
        headers: headers,
      }
    );
    return response;
  } catch (error) {
    throw error.response.data.message;
  }
};

export const verifyOTP = async (phone_no, otp) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    if (!API_KEY) {
      throw new Error("API key is missing");
    }

    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.post(
      "/auth/confirm-otp",
      { phone_no, otp },
      { headers: headers }
    );
    return response;
  } catch (error) {
    throw error.response.data.message;
  }
};


export const couponsList = async () => {
  try {
    // const API_KEY = "3b7fa5a2-4116-4960-be37-f4b218f5b668";
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    if (!API_KEY) {
      throw new Error("API key is missing");
    }

    const headers = {
      "api-key": API_KEY,
    };

    const response = await api.get("/promotion/get-all-coupons", {
      headers: headers,
    });

    return response.data;
  } catch (error) {
    // Log the error for debugging
    console.error("API Error:", error);

    // Check if the error has a response object
    if (error.response && error.response.data) {
      throw error.response.data;
    } else {
      throw new Error("An unknown error occurred");
    }
  }
};

export const addCoupons = async (payload) => {
  try {
    delete payload[0];
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.post("/promotion/create-offer", payload, {
      headers: headers,
    });
    // const response = await api.post("/promotion/create-offer", payload);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const couponUpdate = async (id, payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.put(`/promotion/${id}`, payload, {
      headers: headers,
    });
    return response.data.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const getCouponsById = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(`/promotion/get-coupons/${id}`, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const deleteCouponById = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.delete(`/promotion/delete/${id}`, {
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

export const userList = async () => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get("/auth/user-list", { headers: headers });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const travellerList = async () => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get("/auth/traveller-list", { headers: headers });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const registerUser = async (payload) => {
  try {
    delete payload[0];
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.post("/auth/register-user-2", payload, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const getUserById = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(`/auth/get-user/${id}`, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const checkEmail = async (id, email) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(`/auth/check-email/${id}/${email}`, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const updateUser = async (id, payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.put(`/auth/edit-user/${id}`, payload, {
      headers: headers,
    });
    return response.data.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const deleteUserById = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.delete(`/auth/delete-user/${id}`, {
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

export const bookingList = async () => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get("/payment/get-all-booking", {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const getBookingDetailById = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(`/payment/booking-detail/${id}`, {
      headers: headers,
    });
    // const response = await api.get(`/payment/get-booking-detail/${id}`, {
    //   headers: headers,
    // });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const getBookingPdf = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(`/payment/get-pdf/${id}`, {
      headers: headers,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const configurationList = async () => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get("/vendor-config/list", { headers: headers });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const getConfigurationById = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(`/vendor-config/get-configuration/${id}`, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const updateConfiguration = async (id, payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.put(
      `/vendor-config/update-configuration/${id}`,
      payload,
      { headers: headers }
    );
    return response.data.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const configurationAdd = async (payload) => {
  try {
    delete payload[0];
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.post("/vendor-config/add", payload, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const addToutAndPackage = async (payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.post("/package/create-package", payload, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const fetchGalleryImageUpdate = async (formData) => {
  const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
  const headers = {
    "api-key": API_KEY,
    "Content-Type": "multipart/form-data",
  };
  try {
    const response = await api.post("package/gallery-pic", formData, {
      headers: headers,
    });
    return response;
  } catch (error) {
    console.error("Error uploading package gallery image", error);
    throw error;
  }
};

export const packageList = async () => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get("/package/get-package", {
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

export const getPackageData = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(`/package/get/${id}`, { headers: headers });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const updatePackages = async (id, payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.put(`/package/update-package/${id}`, payload, {
      headers: headers,
    });
    return response.data.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const deletePackageById = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.delete(`/package/delete-package/${id}`, {
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

export const addManageAirportDestinations = async (payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.post("/flight/create-destination", payload, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const updateManageAirportDestinations = async (id, payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.put(
      `/flight/update-destination/${id}`,
      payload,
      { headers: headers }
    );
    return response.data.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const fetchDestinationsList = async () => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get("/flight/get-destinations", {
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

export const getManageDestinationsData = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(`/flight/get-destination/${id}`, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const deleteDestinationById = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.delete(`/flight/delete-destination/${id}`, {
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

export const deleteHotelCityById = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.delete(`/seo/delete-destination/${id}`, {
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

// Fetch country list
export const getCountryList = async () => {
  const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
  const headers = {
    "api-key": API_KEY,
  };
  try {
    // const response = await instance.get(uri.CountryData, { headers });
    const response = await api.get(`/flight/country-name`, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching country list:", error);
    throw error;
  }
};

// Fetch city list by country code
export const getCityList = async (countryCode) => {
  const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
  const headers = {
    "api-key": API_KEY,
  };
  try {
    const response = await api.get(`/flight/city-name/${countryCode}`, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching city list:", error);
    throw error;
  }
};

export const getAirportCode = async (countryCode, cityId) => {
  const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
  const headers = {
    "api-key": API_KEY,
  };

  try {
    // Corrected the URL template literal
    const response = await api.get(
      `/flight/get-flight-code/${countryCode}/${cityId}`,
      { headers: headers }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching airport code:", error);
    throw error;
  }
};

// services/userservice.js
export const getFlightSearchList = async (countryName, cityName) => {
  const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;

  const headers = {
    "api-key": API_KEY,
  };

  try {
    const response = await api.get(`/flight/city-name/${countryName}`, {
      headers: headers,
      params: { cityName: cityName },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching flight search list:", error);
    throw error;
  }
};

export const getFlightSearchListData = async (searchTerm) => {
  const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
  const headers = { "api-key": API_KEY };

  try {
    const response = await api.get("/flight/get-code", {
      headers,
      params: { cityCode: searchTerm },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching flight search list:", error);
    throw error;
  }
};

export const addPopularDestination = async (payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.post("/popular-destination/add", payload, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const fetchPopularDestinationList = async () => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get("/popular-destination/list", {
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

export const getPopularDestinationsData = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(
      `/popular-destination/get-destination/${id}`,
      { headers: headers }
    );
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const updatePopularAirportDestinations = async (id, payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.put(
      `/popular-destination/update-popular-destination/${id}`,
      payload,
      { headers: headers }
    );
    return response.data.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const deletePopularDestinationById = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.delete(
      `/popular-destination/delete-destination/${id}`,
      { headers: headers }
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

export const updateCategories = async (id, payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.put(
      `/package/update-package-category/${id}`,
      payload,
      { headers: headers }
    );
    return response.data.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const getCategorybyId = async (id, payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(`/package/get-category/${id}`, {
      headers: headers,
    });
    return response.data.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const categoriesAdd = async (payload) => {
  try {
    delete payload[0];
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.post("/package/create-category", payload, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const categoriesList = async () => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get("/package/get-package-category", {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const updatePackageDeginations = async (id, payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.put(
      `/package/update-holiday-destination/${id}`,
      payload,
      { headers: headers }
    );
    return response.data.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const getPackageDeginationsbyId = async (id, payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(`/package/get-holiday-destination/${id}`, {
      headers: headers,
    });
    return response.data.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const packageDeginationsAdd = async (payload) => {
  try {
    delete payload[0];
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.post(
      "/package/create-holiday-destination",
      payload,
      { headers: headers }
    );
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const packageDeginationsList = async () => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get("/package/get-holiday-destination", {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const fetchpackageDeginationsList = async () => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get("/package/holiday-destination", {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const fetchEnquiryList = async () => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get("/package/get-enquiry", {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const getEnquiryById = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(`/package/get-enquiry-by-id/${id}`, {
      headers: headers,
    });
    return response.data.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const getAllHotelBooking = async () => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(`/hotel/get-all-hotel-booking`, {
      headers: headers,
    });
    return response.data.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const getHotelBookingDetailById = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(`/hotel/booking-details/${id}`, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const getHotelBookingPdf = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(`/hotel/get-pdf/${id}`, {
      headers: headers,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const getCity = async (searchCity) => {
  const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
  const headers = { "api-key": API_KEY };
  try {
    const response = await api.get("/hotel/get-city", {
      headers,
      params: { cityName: searchCity },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching flight search list:", error);
    throw error;
  }
};

export const fetchConvenienceFeesAndCharges = async () => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get("convenience/get-all-convenience", {
      headers: headers,
    });
    return response?.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const createConvenienceAndCharge = async (payload) => {
  try {
    delete payload[0];
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.post(
      "/convenience/create-convenience",
      payload,
      { headers: headers }
    );
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const updateConvenienceAndCharge = async (id, payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.put(`/convenience/update/${id}`, payload, {
      headers: headers,
    });
    return response.data.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const getConvenienceAndChargeId = async (id, payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(`/convenience/get-convenience/${id}`, {
      headers: headers,
    });
    return response.data.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const deleteById = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.delete(`/convenience/delete/${id}`, {
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

export const fetchPriceFareRuleList = async () => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get("farerule/get-all-fare-rule", {
      headers: headers,
    });
    return response?.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const createPriceFareRule = async (payload) => {
  try {
    delete payload[0];
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.post("/farerule/create-fare-rule", payload, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const getPriceFareRuleId = async (id, payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(`/farerule/get-fare-rule/${id}`, {
      headers: headers,
    });
    return response.data.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const updatePriceFareRule = async (id, payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.put(`/farerule/update/${id}`, payload, {
      headers: headers,
    });
    return response.data.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const deletePriceFareRuleById = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.delete(`/farerule/delete/${id}`, {
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

export const sendMail = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(`/vendor-flight/send-mail/${id}`, {
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

export const logList = async () => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(`/vendor-flight/log-list`, {
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

export const getRequestDetailsById = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(`/vendor-flight/log-detail/${id}`, {
      headers: headers,
    });
    return response.data.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const getBookingRequestDetailsById = async (id, type) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(
      `/vendor-flight/get-log-detail/${id}/${type}`,
      { headers: headers }
    );
    return response.data.data;
  } catch (error) {
    throw error.response.data;
  }
};


export const fetchHiddenFareRuleList = async () => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = { "api-key": API_KEY };

    const response = await api.get("/hiddenfare/hidden-fare-list", { headers });
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching data";
  }
};


export const createHiddenFareRule = async (payload) => {
  try {
    delete payload[0];
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.post("/hiddenfare/create-hidden-fare", payload, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};


export const updateHiddenfare = async (id, payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.put(`/hiddenfare/update/${id}`, payload, {
      headers: headers,
    });
    return response.data.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const getHiddenfareRuleId = async (id, payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(`/hiddenfare/get-hidden-fare/${id}`, {
      headers: headers,
    });
    return response.data.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const tboHotelList = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const url = id ? `/hotel/get-tbo-hotel/${id}` : `/hotel/get-tbo-hotel`;
    const response = await api.get(url, {
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

export const updateTboHotelPrimaryImage = async (payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.post("/hotel/update-tbo-primary-image", payload, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};


export const tboSyncedCityList = async () => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get("/hotel/get-tbo-synced-cities", {
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

export const syncTBoHotelByCityId = async (id) => {
  try {
    const payload = {}
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.post(`/hotel/sync-tbo-hotel/${id}`, payload, {
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

export const setTBoCitySyncHotel = async (payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.post(`/hotel/set-tbo-city-sync-hotel`, payload, {
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error.response.data;
  }
};


export const getFlightDownloadFiltered = async (fromDate, toDate, status, paymentstatus) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const params = new URLSearchParams();
    if (fromDate) params.append('from_date', fromDate);
    if (toDate) params.append('to_date', toDate);
    if (status) params.append('booking_status', status);
    if (paymentstatus) params.append('payment_status', paymentstatus);
    const response = await api.get(`/flight/filtter?${params.toString()}`, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};


export const getFlightDownloadTicket = async (fromDate, toDate, status) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const params = new URLSearchParams();
    if (fromDate) params.append('from_date', fromDate);
    if (toDate) params.append('to_date', toDate);
    if (status) params.append('booking_status', status);
    const response = await api.get(`/flight/download?${params.toString()}`, {
      headers: headers,
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const addHotelCityMetaData = async (payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.post("/seo/hotel-city", payload, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const updateHotelCityMetaData = async (id, payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.put(
      `/seo/hotel-city/${id}`,
      payload,
      { headers: headers }
    );
    return response.data.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const fetchHotelCityList = async () => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get("/seo/get-hotel-city", {
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

export const getSeoHotelCityData = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(`/seo/get-hotel-city/${id}`, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const getFeedbackList = async () => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get("/package/get-package", {
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

export const feedbackList = async () => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get("/feedbacks", {
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

export const createFeedback = async (payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.post("/feedbacks", payload, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const updateFeedback = async (id, payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.put(`/feedbacks/${id}`, payload, {
      headers: headers,
    });
    return response.data.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const fetchFeedbackById = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(`/feedbacks/${id}`, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const deleteFeedbackById = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.delete(`/feedbacks/${id}`, {
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error.response.data;
  }
};


export const getFlightBannersList = async () => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get("/promotion/get-banner-list", {
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error.response.data;
  }
};



export const deleteFlightBannerById = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.delete(`/promotion/delete-banner/${id}`, {
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error.response.data;
  }
};



export const createFlightBanner = async (payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.post("/promotion/create-banner", payload, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const updateFlightBanner = async (id, payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.put(`/promotion/banner-update/${id}`, payload, {
      headers: headers,
    });
    return response.data.data;
  } catch (error) {
    throw error.response.data;
  }
};


export const fetchFlightBannerById = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(`/promotion/banner/${id}`, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};



// ✅ Get Offer List
export const getFlightHomePageOfferList = async () => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get("/offers", {
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// ✅ Delete Offer by ID
export const deleteFlightHomePageOfferById = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.delete(`/offers/${id}`, {
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// ✅ Create New Offer
export const createFlightHomePageOffer = async (payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.post("/offers/create-offer", payload, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// ✅ Update Offer
export const updateFlightHomePageOffer = async (id, payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.put(`/offers/${id}`, payload, {
      headers: headers,
    });
    return response.data.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// ✅ Fetch Offer by ID
export const fetchFlightHomePageOfferById = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(`/offers/${id}`, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const createFollowup = async (payload) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.post("/package/create-followup", payload, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const sendWhatsappNotifications = async (id) => {
  try {
    const API_KEY = process.env.REACT_APP_SMT_V2_API_KEY;
    const headers = {
      "api-key": API_KEY,
    };
    const response = await api.get(`/auth/send-link/${id}`, {
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
